import { openModal } from '@core/components/ModalStack';

export async function open2FAInfoModal() {
  const { TwoFactorInfoModal } = await import('./TwoFactorInfoModal');

  openModal(TwoFactorInfoModal, {});
}
